/* 🤖 this file was generated by svg-to-ts */
export const emperorIconTimeAdd: {
  name: 'time_add';
  data: string;
} = {
  name: 'time_add',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M9 0C4.038 0 0 4.038 0 9c0 4.962 4.038 9 9 9s9-4.038 9-9 -4.04-9-9-9Zm2.44 11.832l-3.45-2.3V3.997h2v4.465l2.55 1.7 -1.109 1.66Z"/><path d="M21 19l0-3 -2 0 0 3 -3 0 0 2 3 0 0 3 2 0 0-3 3 0 0-2Z"/></g></svg>`,
};
